import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import videoImg from "./img/sharedhosting.png";
import VideoModal from "@components/base/Modal/VideoModal/VideoModal";

const BG = {
	blockIntro: {
		top: {},
		bottom: {
			blockTitle: 'Как да си направим сайт в три стъпки',
			blockDesc: 'Виж кои са стъпките, които трябва да извървиш, за да изградиш своето онлайн присъствие. Важно е да имаш отправна точка и идея какво точно искаш да направиш онлайн.',
			titleSize: 'h4',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: 'jiponovphotography.com',
		  url: 'https://www.lubomirjiponovphotography.com',
		  img: videoImg,
		  platform: 'youtube',
		  videoId: 'wrJFb2p2Rco',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-10-28T12:37:43+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockIntro: {
		top: {},
		bottom: {
			blockTitle: 'How to create your website in just three steps',
			blockDesc: 'Discover the key steps you need to follow to create your online presence. Start with a clear vision and turn your ideas into a successful online project.',
			titleSize: 'h4',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: 'jiponovphotography.com',
		  url: 'https://www.lubomirjiponovphotography.com',
		  img: videoImg,
		  platform: 'youtube',
		  videoId: 'wrJFb2p2Rco',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-10-28T12:37:43+00:00",
		  watchText: 'Watch on YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];